/* eslint-disable */
import React, { useEffect, useRef } from 'react';
import { IconButton, InputBase, TextField, Typography, Button, Switch } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Box } from '@mui/system';
// import DropZone from '../Components/DropZone';
import PageLayout from '../Components/PageLayout';
import DatePicker, { DateObject } from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import persian_en from "react-date-object/locales/persian_en";
// import { ReactComponent as CalendarIcon } from "../Assets/svg/CalendarIcon.svg";
// import { ReactComponent as CopyIcon } from "../Assets/svg/CopyIcon.svg";
// import { ReactComponent as ContactIcon } from "../Assets/svg/ContactIcon.svg";
import { ReactComponent as CityIcon } from "../Assets/svg/CityIcon.svg";
// import { ReactComponent as FilterIcon } from "../Assets/svg/FilterIcon.svg";
// import { ReactComponent as NotificationIcon } from "../Assets/svg/NotificationIcon.svg";
// import { ReactComponent as LabelsIcon } from "../Assets/svg/LabelsIcon.svg";
import { ReactComponent as CloseIcon } from "../Assets/svg/CloseIcon.svg";
import { ReactComponent as MapMarkerIcon } from "../Assets/svg/MapMarkerIcon.svg";
import { ReactComponent as ArrowRightIcon } from "../Assets/svg/ArrowRightIcon.svg";
import { ReactComponent as SreachIcon } from "../Assets/svg/SreachIcon.svg";
import { ReactComponent as DownloadIcon } from "../Assets/svg/DownloadIcon.svg";
import { ReactComponent as PersonList } from "../Assets/svg/PersonList.svg";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Slide from '@mui/material/Slide';
// import { PropertyContext } from '../context/property-context';
import data from '../api/melkData.json';
// import Alert from '@mui/material/Alert';
// import Collapse from '@mui/material/Collapse';
// import Backdrop from '@mui/material/Backdrop';
// import CircularProgress from '@mui/material/CircularProgress';
import http from '../api/axiosInstance';
import { NumericFormat } from 'react-number-format';
// import {
//     useParams
// } from "react-router-dom";
import { TileLayer, useMapEvents, Marker, Popup, MapContainer } from 'react-leaflet'
import { useSnackbar } from 'notistack';
// import List from '@mui/material/List';
// import ListItem from '@mui/material/ListItem';
// import ListItemButton from '@mui/material/ListItemButton';
// import ListItemIcon from '@mui/material/ListItemIcon';
// import ListItemText from '@mui/material/ListItemText';
import ButtonNavigation from '../Components/ButtonNavigation';
import PropItem from '../Components/PropItem';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as SettingIcon } from "../Assets/svg/SettingIcon.svg";
import { useSearchPropStore } from '../store/searchProperty';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode } from 'swiper';
// import InfiniteScroll from "react-infinite-scroll-component";
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import useForceUpdate from 'use-force-update';
import { useUserStore } from '../store/user';
import moment from "moment-jalaali"
import {
    Picker,
    format,
    newDate,
    DatePickerConfig,
} from '@persian-tools/persian-mobile-datepicker';
import { config } from '../Components/persian-mobile-datepicker-config'
import { priceItems, meterItems, dateTypes } from "../api/ListData"
import { scrollingDiv } from '../Components/ScrollRightToLeftDrag'
import Cookies from 'js-cookie'


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function SearchByUser({moreSearchDataTmp,setMoreSearchDataTmp,handleSetMoreSearchDataTmp}) {

    const [propKey, setPropKey] = React.useState(0);


    const handleClickOpenUsersModal = () => {
        getUsers(true)
        setTimeout(function () {
            if (document && typeof document.getElementById("users-content") !== 'undefined' && document.getElementById("users-content") !== null && Users.length > 0) {
                console.log("Users Use")
                document.getElementById("users-content").addEventListener('scroll', onUsersScroll)
                return () => document.getElementById("users-content").removeEventListener('scroll', onUsersScroll)
            }
        }, 500)
        setOpenUsersModal(true);
    };

    const handleOpenUsersModalClose = () => {
        setOpenUsersModal(false);
    };


     ///////////////////////////////////////User Modal
     const [openUsersModal, setOpenUsersModal] = React.useState(false)
     const [labelsChecked, setLabelsChecked] = React.useState({})
 
     const [Users, setUsers] = React.useState([]);
     const [UserOffset, setUserOffset] = React.useState(0);
     const [HasMoreUsers, setHasMoreUsers] = React.useState(true);
     const [UsersLoading, setUsersLoading] = React.useState(false);
     const [inPlusingUser, setinPlusingUser] = React.useState(true);
 
 
     const getUsers = (resetState = false) => {
         if (resetState) {
             setUsers([])
             console.log("reset", Users)
             setPropKey(propKey => propKey++)
             setUserOffset(0);
             setHasMoreUsers(true)
         }
 
         setUsersLoading(true)
         try {
             http({
                 // url of the api endpoint (can be changed)
                 url: "/users/get-my-users",
                 method: "GET",
                 headers: {
                     "Authorization": `Bearer ${Cookies.get('token')}`
                 }
             }).then((res) => {
                 console.log("users", res);
 
                 const tmpProp = [...Users]
                 if (res.data.result.Users.length > 0) {
                     if (!resetState) {
                         res.data.result.Users.map((item, index) => {
                             tmpProp.push(item)
                         })
                         setUsers(tmpProp)
 
                         setPropKey(propKey => propKey++)
                     }
                     else
                         setUsers(res.data.result.Users)
 
 
                     setPropKey(propKey => propKey++)
 
                 } else {
                     console.log("End")
                     setHasMoreUsers(false)
                     if (resetState) setUsers([])
 
                 }
 
                 console.log("users ff", Users)
                 setUsersLoading(false)
                 setTimeout(function () { setinPlusingUser(true) }, 1000)
             });
 
         } catch (e) {
             console.error(e);
             setUsersLoading(false)
 
         }
 
 
     }
 
 
     const onUsersScroll = () => {
         if (document.getElementById("users-content")) {
 
             const scrollTop = document.getElementById("users-content").scrollTop
             const scrollHeight = document.getElementById("users-content").scrollHeight
             const clientHeight = document.getElementById("users-content").clientHeight
             if (scrollTop + clientHeight >= scrollHeight && inPlusingUser) {
                 setUserOffset(UserOffset => UserOffset + 1);
                 // setSearchData({"name":"Offset","value":UserOffset})
                 console.log("UserOffset", UserOffset)
                 setinPlusingUser(false)
             }
         }
     }
 
     useEffect(() => {
         setTimeout(function () {
             if (document && typeof document.getElementById("users-content") !== 'undefined' && document.getElementById("users-content") !== null && Users.length > 0) {
                 console.log("Users Use")
                 document.getElementById("users-content").addEventListener('scroll', onUsersScroll)
                 return () => document.getElementById("users-content").removeEventListener('scroll', onUsersScroll)
             }
         }, 500)
 
 
     }, [Users])
 
     useEffect(() => {
         console.log("offset use")
 
         if (HasMoreUsers && Users.length) {
             getUsers()
         }
     }, [UserOffset])


     const handleSetUsers = (user) => {
        handleSetMoreSearchDataTmp("Users", user?.id, false, true)
    }

    const usernameById = (item) => {
        console.log("🚀 ~ usernameById ~ Users:", Users)

        if (Users?.length) {
            let user = Users.filter(user => user.id == item)
            return user && user[0]?.username
        }
    }

    return (
        <>

            <Box sx={{ width: '100%' }}>
                <label htmlFor='meter' className='f-16 text-label'>کاربر ثبت کننده</label>
                <Box className="inputs-container" sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }} onClick={handleClickOpenUsersModal}>
                    <span>
                        {moreSearchDataTmp?.Users?.length ? moreSearchDataTmp.Users.map((item, index) => {
                            return <span key={index}>{usernameById(item)} {index != moreSearchDataTmp.Users.length - 1 && "،"} </span>
                        }) : ""}

                    </span>
                    <ArrowRightIcon className='rotate-180-minus' />
                </Box>
            </Box>

            {openUsersModal && <Dialog className="dialog-box"
                fullScreen
                open={openUsersModal}
                onClose={handleOpenUsersModalClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                    <Toolbar>

                        <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                            کاربران
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleOpenUsersModalClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                    </Toolbar>
                </AppBar>
                <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', height: "calc(100vh - 140px)!important", overflow: "auto" }} id="uset-content">
                    <Box >
                        <Box sx={{ display: "flex", flexDirection: "column", gap: '15px', mt: "15px" }}>
                            {
                                Users && Users.length > 0 ?
                                    Users.map((item, index) => (

                                        <Button className={`inputs-container has-arrow ${moreSearchDataTmp?.Users?.includes(item?.id) ? 'checked' : ""}`} sx={{ display: "flex", justifyContent: "space-between", width: "100%", p: 1 }} onClick={() => handleSetUsers(item)} key={index}>
                                            <Box sx={{ display: "flex", gap: '5px', alignItems: 'center' }}>

                                                <Typography component="span">{item?.username}</Typography>
                                            </Box>
                                            {/* <IconButton>
                                                <PenIcon2 />
                                            </IconButton> */}
                                        </Button>

                                    ))
                                    : !UsersLoading ? <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box> : ""
                            }
                            {
                                UsersLoading ? <Box sx={{ textAlign: 'center' }}>درحال بارگیری...</Box> : ""
                            }

                        </Box>
                    </Box>
                </Box>
                <Button className='green-btn' onClick={handleOpenUsersModalClose} sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>ثبت</Button>
            </Dialog>}
        </>
    );
}

export default SearchByUser;